import collection1 from './Assets/Images/collection1.webp';
import collection2 from './Assets/Images/collection2.webp';
import collection3 from './Assets/Images/collection3.webp';
import founder1 from './Assets/Images/founder1.webp';
import founder1g from './Assets/Images/founder1g.webp';
import founder2 from './Assets/Images/founder2.webp';
import founder2g from './Assets/Images/founder2g.webp';
import founder3 from './Assets/Images/founder3.webp';
import founder3g from './Assets/Images/founder3g.webp';
import heroVideo from './Assets/Images/heroVideo.webp';
import trend1 from './Assets/Images/trend1.webp';
import trend2 from './Assets/Images/trend2.webp';
import trend2c from './Assets/Images/trend2c.webp';
import trend3 from './Assets/Images/trend3.webp';
import trend3c from './Assets/Images/trend3c.webp';
import blog1 from './Assets/Images/blog1.webp';
import blog2 from './Assets/Images/blog2.webp';
import blog3 from './Assets/Images/blog3.webp';
import blog4 from './Assets/Images/blog4.webp';
import blog5 from './Assets/Images/blog5.webp';
import blog1c from './Assets/Images/blog1c.webp';
import blog2c from './Assets/Images/blog2c.webp';
import blog3c from './Assets/Images/blog3c.webp';
import blog4c from './Assets/Images/blog4c.webp';
import blog5c from './Assets/Images/blog5c.webp';
import testimonial1 from './Assets/Images/testimonial1.webp';
import testimonial2 from './Assets/Images/testimonial2.webp';
import testimonial3 from './Assets/Images/testimonial3.webp';
import testimonialBig from './Assets/Images/testimonialBig.webp';
import aboutImg from './Assets/Images/aboutImg.webp';
import aboutFabric from './Assets/Images/aboutFabric.webp';
import collectionVideo1 from './Assets/videos/collection1.mp4';
import collectionVideo2 from './Assets/videos/collection2.mp4';
import collectionVideo3 from './Assets/videos/collection3.mp4';
import collectionVideo4 from './Assets/videos/collection4.mp4';
import chart1 from './Assets/Images/chart1.png';
import chart2 from './Assets/Images/chart2.png';







const images={
collection1,
collection2,
collection3,
founder1,
founder1g,
founder2,
founder2g,
founder3,
founder3g,
heroVideo,
trend1,
trend2,
trend3,
trend2c,trend3c,
blog1,blog2,blog3,blog4,blog5,blog1c,blog2c,blog3c,blog4c,blog5c,
testimonial1,testimonial2,testimonial3, testimonialBig,
aboutImg,aboutFabric,
collectionVideo1,collectionVideo2,collectionVideo3,collectionVideo4,
chart1,chart2,



}

export default images;